/**
 * Opens DevExtreme Chat's native Edit/Delete context menu for the bubble containing `source`.
 * Custom message templates make the native right-click affordance undiscoverable, so own-message
 * bubbles expose a visible ellipsis that dispatches the same contextmenu event.
 */
export function openChatMessageActions(source: HTMLElement): void {
  const bubble = source.closest('.dx-chat-messagebubble');
  if (!(bubble instanceof HTMLElement)) return;

  const rect = source.getBoundingClientRect();
  bubble.dispatchEvent(
    new MouseEvent('contextmenu', {
      bubbles: true,
      cancelable: true,
      clientX: rect.left + rect.width / 2,
      clientY: rect.bottom
    })
  );
}
